module.exports = __webpack_public_path__ + "img/open-gwas-logo.f7f369b4.png";